// Allen context signal — a tiny reactive singleton so the GLOBAL docked Ask Allen
// (AllenDock, mounted in App.vue) can tailor its suggested prompts to the surface
// the user is on, even for surfaces that are internal tab state (Explore/Zones/
// Actions live on one route). Surfaces call setAllenContext(); the dock reads it.
//
// kind: 'today' | 'explore' | 'zones' | 'actions' | 'zone' | 'general'
// zone: the zone name, when kind is 'zones' (focused zone) or 'zone' (a zone page).
import { reactive } from 'vue'
import { i18n } from '@/i18n'

export const allenContext = reactive({ kind: 'general', zone: '' })

export function setAllenContext(kind = 'general', zone = '') {
  allenContext.kind = kind
  allenContext.zone = zone || ''
}

// Live starter prompts per surface. You can always ask Allen anything — these are
// just context-relevant openers. {zone} is interpolated when present.
// Texts in askAllen.prompts.* — read when called, so they follow the reader's language
// (the dock calls this inside a computed, which re-runs on a language switch).
export function allenPromptsFor(kind, zone) {
  const { t } = i18n.global
  const z = zone || t('askAllen.prompts.thisZone')
  const three = (set) => [0, 1, 2].map((i) => t(`askAllen.prompts.${set}.${i}`, { zone: z }))
  switch (kind) {
    case 'explore':
      return three('explore')
    case 'zones':
      return zone ? three('zoneFocused') : three('zones')
    case 'actions':
      return three('actions')
    case 'zone':
      return three('zone')
    case 'today':
    case 'general':
    default:
      return three('general')
  }
}
